export default {
  system: {
    project_name: "Système de Santé Pellar",
    loading: "Chargement…",
    empty_data: "Pas de donnée...",
    version: "Version",
    submitting_feeback: "Attendez svp...",
    update_button: "Mise à jour",
    edit_button: "Editer",
    sending_feeback: "Envoi en cours..."
  },
  common: {
    created: "Créé",
    sites: "Localisations",
    events: "Evénements",
    assets: "Utilisateurs",
    campaigns: "Campagnes",
    option_select_site: "Sélectionnez une localisation svp",
    option_select_asset: "Sélectionnez un utilisateur svp",
    site: "Localisation",
    asset: "Utilisateur",
    event: "Evénement",
    type: "Type",
    temperature: "Température",
    location: "Localisation",
    last_location: "Dernière localisation",
    value: "Valeur",
    longitude: "Longitude",
    latitude: "Latitude",
    name: "Nom",
    status: "Statut",
    response: "Réponse",
    label_last_check: "Dernière Vérification",
    label_last_seen: "Vu pour la dernière fois",
    key: "Clef",
    phone: "Téléphone",
    time: "Temps",
    distance: "Variation de la distance",
    start_date: "Début",
    end_date: "Fin",
    help: "Aide",
    back: "Retourner",
    action: "Action",
    remove: "Retirer"
  },
  nav: {
    sites: "Localisations",
    campaigns: "Campagnes",
    assets: "Utilisateurs",
    events: "Evénements",
    help: "Aide"
  },
  auth: {
    login_prompt: "Vous n’avez pas de compte?",
    register_prompt: "Vous avez déjà un compte?",
    login_text: "Se connecter",
    register_text: "S’inscrire ",

    login_title: "Identifiant",
    register_title: "Inscription à un nouveau compte",
    interest_title: "Enregistrez votre intérêt",
    login_button: "Connexion",
    logout_button: "Déconnexion",
    register_button: "Inscription",
    interest_button: "Inscription",

    label_email: "Adresse e-mail",
    input_email_placeholder: "Entrez votre adresse e-mail",
    label_password: "Mot de passe",
    input_password_placeholder: "Entrez votre mot de passe",
    label_firstname: "Prénom",
    input_firstname_placeholder: "Entrez votre prénom",
    label_lastname: "Nom",
    input_lastname_placeholder: "Entrez votre nom",

    form_email_invalid_error: "Format de l’adresse e-mail invalide",
    form_email_required_error: "Adresse e-mail requise",
    form_password_invalid_error:
      "Le mot de passe doit comporter au moins 3 caractères",
    form_password_required_error: "Mot de passe requis",
    from_firstname_invalid_error: "Le prénom doit comporter au moins 2 lettres",
    form_firstname_required_error: "Prénom requis",
    from_lastname_invalid_error: "Le nom doit comporter au moins 2 lettres",
    form_lastname_required_error: "Nom requis",
    interest_prompt: "Intéressé par cette plateforme?",
    interest_text: "Enregistrez votre intérêt",
    interest_success_msg:
      "Merci de votre intérêt, nous vous répondrons sous peu."
  },
  site: {
    list_title: "Localisations",
    create_title: "Créer une nouvelle localisation",
    update_title: "Mettre à jour la localisation",
    create_button: "Créer la localisation",

    label_name: "Nom",
    label_latitude: "Latitude",
    label_longitude: "Longitude",
    label_notes: "Notes",

    form_name_invalid_error:
      "Le nom de la localisation doit comporter au moins 2 lettres",
    form_name_required_error: "Nom de la localisation requis"
  },
  campaign: {
    list_title: "Campagnes de confinement",
    create_title: "Créer une campagne",
    update_title: "Mettre à jour la campagne",
    items_title: "Tous les bénéficiaires",
    items: "Bénéficiaires",
    items_title_flagged: "Bénéficiaires signalés",
    create_button: "Créer une campagne",
    label_name: "Nom de la campagne",
    label_dates: "Dates",
    label_sms_message: "Exemple de message SMS",
    form_site_required_error: "La localisation est requise",
    form_name_required_error: "Le nom de la campagne est requis",
    form_name_invalid_error:
      "Le nom de la campagne doit comporter au moins 2 lettres",
    send_sms_button: "Envoyer un SMS",
    send_sms_to_all_button: "Envoyer des SMS à tous",
    send_sms_to_all_confirm_msg:
      "Etes-vous sûr de vouloir envoyer des SMS à tous?",
    send_confirm_msg: "Etes-vous sûr de vouloir envoyer un SMS?",
    campaign_detail_events: "Localisations signalées",
    edit_items_button: "Modifier les destinataires",
    edit_campaign_button: "Modifier la campagne",

    status_pending: "En attente",
    status_active: "Envoi en cours",
    status_paused: "En pause",
    status_complete: "Terminé",

    item_status_pending: "En attente",
    item_status_active: "Envoi en cours",
    item_status_exempt: "Exempter",
    item_status_complete: "Terminé",

    item_response_status_pending: "En attente",
    item_response_status_located: "Actionné",
    item_response_status_exception: "Enquêter",
    item_response_status_complete: "Terminé",

    item_add_button: "Ajouter des bénéficiaires"
  },
  event: {
    list_title: "Mes Evénements",
    create_title: "Créer un événement",
    create_button: "Créer un événement",
    label_recent_events: "Evénements récents",
    form_asset_required_error: "L’utilisateur est requis",
    form_site_required_error: "La localisation est requise",
    label_last_check: "Dernière vérification",
    trigger_prompt: "Cet évènement est déclenché par",
    type_temperature: "Température",
    type_location: "Localisation"
  },
  asset: {
    list_title: "Mes utilisateurs",
    create_title: "Créer un utilisateur",
    update_title: "Mettre à jour l’utilisateur",
    create_button: "Créer un utilisateur",
    import_title: "Importer des utilisateurs",
    import_button: "Importer des utilisateurs ",
    upload_button: "Télécharger",
    label_recent_assets: "Utilisateurs récents",
    label_name: "Nom",
    input_name_placeholder: "Entrer le nom de l’utilisateur",
    label_phone: "Téléphone",
    label_image: "Image",
    label_encoding: "Encodage",
    label_hash: "Hash",
    label_csv_file: "Document CSV",

    form_site_required_error: "La localisation est requise",
    form_name_required_error: "Le nom d’utilisateur est requis",
    form_name_invalid_error:
      "Le nom d’utilisateur doit comporter au moins 2 lettres."
  },
  help: {
    title: "Aide",
    concepts_title: "Concepts",
    concepts_content_p1:
      " Le système est conçu pour utiliser les SMS et la géolocalisation pour mettre en exécution l’auto-confinement.",
    concepts_content_p2:
      "Le système enverra régulièrement des SMS aux utilisateurs leur demandant de prouver qu’il sont auto-confinés. La localisation des utilisateurs (latitude et longitude) sera affichée sur la page de la campagne. Un utilisateur réalisant beaucoup de déplacement sera signalé pour un examen plus approfondi.",
    concepts_content_p3_1:
      'Le système utilise le terme "Localisation" pour décrire un regroupement logique d’utilisateurs.',
    concepts_content_p3_2:
      'Le système utilise le terme "Utilisateurs" pour décrire les personnes qui doivent être auto-confinées.',
    concepts_content_p3_3:
      'Le système utilise le terme "Evénements" pour décrire quelque chose qui est arrivé à un utilisateur, par exemple un changement de localisation',
    concepts_content_p3_4:
      'Le système utilise le terme "Campagnes" pour décrire un regroupement logique des campagnes SMS aux utilisateurs.',
    sms_campaign_title: "Création d’une campagne SMS",
    campaign_location: "Créer une localisation",
    campaign_location_introduce:
      "un emplacement pour regrouper les campagnes et les utilisateurs. Créer une localisation",
    campaign_import: "Importer des utilisateurs",
    campaign_import_introduce:
      "importer les noms et numéros de téléphone, un modèle est fourni ci-dessous",
    campaign_create: "Créer une campagne",
    campaign_create_introduce:
      "Tous les utilisateurs à cette localisation seront automatiquement rattachés à la campagne. Les SMS seront programmés automatiquement lorsque la campagne sera créée. Vous pouvez gérer la campagne via la page de la campagne.",
    campaign_status_title: "Statut de la campagne",
    campaign_status_pending: "En attente",
    campaign_status_pending_introduce: "La campagne est prête",
    campaign_status_active: "Active",
    campaign_status_active_introduce:
      "Le système envoie des SMS à tous les utilisateurs dans la campagne.",
    campaign_status_complete: "Terminée",
    campaign_status_complete_introduce:
      "Le système a envoyé tous les SMS et la campagne est arrivée à sa date de fin",
    system_introduce_title: "Comment fonctionne le système ?",
    system_introduce_content:
      'Les utilisateurs recevront un SMS leur demandant d’ouvrir une page web. Cette page web utilise les fonctionnalités de géolocalisation intégrées au téléphone afin d’envoyer la localisation de la personne au serveur. La localisation de ces individus sera affichée sur la page de campagne. Le système n’impose pas à l’utilisateur de rester à un certain emplacement. Le système a seulement besoin de s’assurer que la localisation de la personne n’a pas changé depuis la dernière vérification. Lorsque la localisation actuelle est différente de la précédente, l’utilisateur sera signalé pour un examen plus poussé. Sera considéré comme "différente" une localisation se trouvant à au moins 1 km de la localisation précédente.',

    csv_template_title: "Modèle CSV",
    csv_template_promt_start: "Vous pouvez télécharger un",
    csv_template_promt_end: "exemple de modèle ici.",
    contact_title: "Contact",
    contact_promt:
      "Vous pouvez contacter notre service client à l’adresse https://pellar.zendesk.com"
  }
};
